import React from 'react';
import { Accordion } from '../components/Accordion';
import { Sparkles, Moon, Sun, Heart, CheckCircle2 } from 'lucide-react';
export function LandingPage() {
  const productImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/oaZETDAm6QZkvwW2z9B84A/MOCKUP_SANTUARIO_DE_CALMA_PORTADA_HOTMART.png',
    title: 'El Sistema Completo',
    desc: 'Tu hoja de ruta paso a paso para desactivar la ansiedad y recuperar el control.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/d5vkYuj119FF5B35K56gNR/MOCKUP_365_EN_CONEXION_1.1.png',
    title: '365 Días en Conexión',
    desc: 'Oraciones semanales para acompañarte durante todo el año: 52 semanas, 52 oraciones. Repite 1 oración al día durante 7 días… y deja que tu mente aprenda a descansar.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/pVwK8962u3Zgf1JmrUWXFo/MOCKUP_PRESENTACION_SANTUARIO_DE_CALMA.png',
    title: 'Presentación Guiada (Entrada al Santuario)',
    desc: 'Una presentación clara y visual para que entiendas en minutos qué contiene el pack y cómo usarlo paso a paso.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/nd5nS7DNN6GaZEyxoVTnvV/76F6895B-2B15-4C86-A49E-5B2AB15802A1.png',
    title: 'Audios de Acompañamiento',
    desc: 'Incluye el audiolibro del contenido (para escuchar en vez de leer) + 2 canciones originales: Canción de la Mañana (activarte, agradecer y bajar la ansiedad) y Canción de la Noche (calma profunda para dormir en paz).'
  }];
  const benefits = ['Calma mental en minutos', 'Rutina simple para volver al presente', 'Audios y lectura suave para acompañarte', 'Herramientas prácticas + espiritualidad ligera', 'Para días de ansiedad, sobrecarga o insomnio'];
  const testimonials = [{
    name: 'Sofía G.',
    age: '32',
    text: 'Me ha ayudado a encontrar mi centro en días caóticos. Un respiro necesario.'
  }, {
    name: 'Marcos P.',
    age: '45',
    text: 'Audios que realmente relajan. Por fin duermo mejor y con más tranquilidad.'
  }, {
    name: 'Ana R.',
    age: '28',
    text: 'Siempre quise conectar con mi interior y esto me ha dado las herramientas para empezar.'
  }];
  const faqItems = [{
    title: '¿Esto sustituye terapia?',
    content: 'No, es un complemento para tu bienestar personal y espiritual, no reemplaza la atención médica o psicológica profesional.'
  }, {
    title: '¿Cómo recibo el material?',
    content: 'Acceso inmediato y completo a todo el contenido digital desde tu área de miembro.'
  }, {
    title: '¿Cuánto tiempo necesito al día?',
    content: 'Puedes dedicarle desde 5 minutos. Diseñado para adaptarse a tu ritmo y disponibilidad.'
  }, {
    title: '¿Funciona si tengo ansiedad fuerte?',
    content: 'Es una herramienta de apoyo para la gestión del estrés y la búsqueda de calma. Si tu ansiedad es severa, te recomendamos buscar apoyo profesional.'
  }];
  const legalItems = [{
    title: 'Política de Privacidad',
    content: 'En Santuario de Calma, nos tomamos muy en serio tu privacidad. Tus datos personales serán tratados con la máxima confidencialidad y solo se utilizarán para gestionar tu acceso al curso y enviarte comunicaciones relacionadas. No compartimos tus datos con terceros sin tu consentimiento explícito.'
  }, {
    title: 'Términos y Condiciones',
    content: 'Al adquirir este producto digital, obtienes una licencia personal e intransferible para su uso. Queda prohibida la reproducción, distribución o venta del contenido sin autorización previa. El acceso es de por vida para la versión actual del producto.'
  }];
  return <div className="min-h-screen bg-neutral-950 text-neutral-200 font-sans selection:bg-gold-500 selection:text-white" data-id="element-11">
      {/* 1. HERO SECTION */}
      <section className="relative min-h-[90vh] flex flex-col justify-center items-center text-center px-6 py-20 overflow-hidden" data-id="element-12">
        {/* Background Gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-dark-900 via-dark-800 to-neutral-950 z-0" data-id="element-13" />

        {/* Subtle decorative glow */}
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-gold-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-14" />

        <div className="relative z-10 max-w-3xl mx-auto space-y-8 animate-fade-in-up" data-id="element-15">
          <div className="flex justify-center mb-6" data-id="element-16">
            <Sparkles className="w-8 h-8 text-gold-500 opacity-80" data-id="element-17" />
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-semibold leading-tight tracking-normal text-transparent bg-clip-text bg-gradient-to-r from-neutral-100 via-neutral-200 to-neutral-400" data-id="element-18">
            Cuando la mente no para, <br data-id="element-19" />
            <span className="text-gold-500" data-id="element-20">el alma necesita un refugio.</span>
          </h1>

          <p className="text-lg md:text-xl text-neutral-400 font-light max-w-2xl mx-auto leading-relaxed" data-id="element-21">
            Un santuario digital creado con amor para acompañarte hacia la calma
            interior, paso a paso, sin prisa, sin presión.
          </p>

          <div className="pt-8" data-id="element-22">
            <a href="#compra" className="inline-block bg-gold-500 hover:bg-gold-600 text-white font-medium text-lg px-10 py-4 rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_20px_rgba(212,175,55,0.3)] focus:outline-none focus:ring-2 focus:ring-gold-400 focus:ring-offset-2 focus:ring-offset-dark-900" data-id="element-23">
              Accede al Santuario de Calma
            </a>
          </div>
        </div>
      </section>

      {/* 2. LO QUE RECIBES */}
      <section className="py-24 px-6 bg-neutral-950" data-id="element-24">
        <div className="max-w-7xl mx-auto" data-id="element-25">
          <div className="text-center mb-16" data-id="element-26">
            <h2 className="text-3xl md:text-4xl font-serif text-gold-500 mb-4" data-id="element-27">
              Lo que recibes
            </h2>
            <div className="h-px w-24 bg-gradient-to-r from-transparent via-gold-500 to-transparent mx-auto opacity-50" data-id="element-28"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12" data-id="element-29">
            {productImages.map((item, idx) => <div key={idx} className="group flex flex-col items-center text-center space-y-6" data-id="element-30">
                <div className="relative w-full aspect-[4/5] overflow-hidden rounded-lg bg-neutral-900 border border-neutral-800 group-hover:border-gold-500/30 transition-colors duration-500" data-id="element-31">
                  <img src={item.src} alt={item.title} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700 ease-out" data-id="element-32" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-33" />
                </div>
                <div className="space-y-2 px-2" data-id="element-34">
                  <h3 className="text-xl font-serif text-neutral-200 group-hover:text-gold-400 transition-colors" data-id="element-35">
                    {item.title}
                  </h3>
                  <p className="text-sm text-neutral-400 font-light leading-relaxed" data-id="element-36">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 3. BENEFICIOS */}
      <section className="py-24 px-6 bg-dark-800 relative overflow-hidden" data-id="element-37">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-neutral-800 to-transparent" data-id="element-38"></div>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-neutral-800 to-transparent" data-id="element-39"></div>

        <div className="max-w-4xl mx-auto text-center" data-id="element-40">
          <div className="mb-12 inline-flex items-center justify-center p-3 rounded-full bg-neutral-900/50 border border-neutral-800" data-id="element-41">
            <Sun className="w-6 h-6 text-gold-500" data-id="element-42" />
          </div>

          <h2 className="text-3xl md:text-5xl font-serif text-neutral-100 mb-16" data-id="element-43">
            Recupera tu paz interior
          </h2>

          <div className="grid gap-6 md:gap-8 text-left max-w-2xl mx-auto" data-id="element-44">
            {benefits.map((benefit, idx) => <div key={idx} className="flex items-start space-x-4 p-4 rounded-xl hover:bg-neutral-800/50 transition-colors duration-300" data-id="element-45">
                <CheckCircle2 className="w-6 h-6 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-46" />
                <span className="text-lg md:text-xl text-neutral-300 font-light" data-id="element-47">
                  {benefit}
                </span>
              </div>)}
          </div>
        </div>
      </section>

      {/* 4. TESTIMONIOS */}
      <section className="py-24 px-6 bg-neutral-950" data-id="element-48">
        <div className="max-w-6xl mx-auto" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-serif text-center text-gold-500 mb-16" data-id="element-50">
            Historias de Calma
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-51">
            {testimonials.map((t, idx) => <div key={idx} className="bg-dark-900 p-8 rounded-2xl border border-neutral-800 relative" data-id="element-52">
                <div className="absolute -top-4 left-8 text-6xl font-serif text-gold-500/20" data-id="element-53">
                  "
                </div>
                <p className="text-neutral-300 font-light italic mb-6 relative z-10 leading-relaxed" data-id="element-54">
                  {t.text}
                </p>
                <div className="flex items-center space-x-3" data-id="element-55">
                  <div className="w-10 h-10 rounded-full bg-neutral-800 flex items-center justify-center text-gold-500 font-serif" data-id="element-56">
                    {t.name[0]}
                  </div>
                  <div data-id="element-57">
                    <div className="text-sm font-medium text-neutral-200" data-id="element-58">
                      {t.name}
                    </div>
                    <div className="text-xs text-neutral-500" data-id="element-59">{t.age} años</div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 5. FAQ */}
      <section className="py-24 px-6 bg-dark-800" data-id="element-60">
        <div className="max-w-3xl mx-auto" data-id="element-61">
          <h2 className="text-3xl md:text-4xl font-serif text-center text-neutral-100 mb-12" data-id="element-62">
            Preguntas Frecuentes
          </h2>
          <Accordion items={faqItems} data-id="element-63" />
        </div>
      </section>

      {/* 6. LEGAL */}
      <section className="py-12 px-6 bg-neutral-950 border-t border-neutral-900" data-id="element-64">
        <div className="max-w-3xl mx-auto" data-id="element-65">
          <h3 className="text-sm font-medium text-neutral-500 uppercase tracking-widest mb-6 text-center" data-id="element-66">
            Información Legal
          </h3>
          <Accordion items={legalItems} data-id="element-67" />
        </div>
      </section>

      {/* 7. COMPRA */}
      <section id="compra" className="py-32 px-6 bg-gradient-to-b from-dark-900 to-black text-center relative overflow-hidden" data-id="element-68">
        {/* Glow effect */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-gold-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-69" />

        <div className="relative z-10 max-w-4xl mx-auto space-y-10" data-id="element-70">
          <Heart className="w-12 h-12 text-gold-500 mx-auto animate-pulse" data-id="element-71" />

          <h2 className="text-4xl md:text-6xl font-serif text-white" data-id="element-72">
            Accede ahora a tu <br data-id="element-73" />
            <span className="text-gold-500" data-id="element-74">Santuario de Calma</span>
          </h2>

          <p className="text-xl text-neutral-400 font-light max-w-2xl mx-auto" data-id="element-75">
            Invierte en tu paz interior. Empieza hoy tu camino hacia una vida
            más serena y consciente.
          </p>

          {/* Offer Block */}
          <div className="bg-neutral-900/80 border border-neutral-800 rounded-2xl p-8 md:p-10 max-w-xl mx-auto text-left space-y-6" data-id="element-76">
            <h3 className="text-2xl font-serif text-gold-500 text-center" data-id="element-77">
              ¿Qué incluye?
            </h3>
            <ul className="space-y-3" data-id="element-78">
              <li className="flex items-start space-x-3" data-id="element-79">
                <CheckCircle2 className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-80" />
                <span className="text-neutral-300 font-light" data-id="element-81">
                  El Sistema Completo de Reprogramación
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-82">
                <CheckCircle2 className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-83" />
                <span className="text-neutral-300 font-light" data-id="element-84">
                  365 Días en Conexión (52 oraciones semanales)
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-85">
                <CheckCircle2 className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-86" />
                <span className="text-neutral-300 font-light" data-id="element-87">
                  Presentación Guiada (Entrada al Santuario)
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-88">
                <CheckCircle2 className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-89" />
                <span className="text-neutral-300 font-light" data-id="element-90">
                  Audiolibro completo + 2 canciones originales
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-91">
                <CheckCircle2 className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-92" />
                <span className="text-neutral-300 font-light" data-id="element-93">
                  Acceso inmediato y de por vida
                </span>
              </li>
            </ul>

            <div className="text-center pt-4 border-t border-neutral-800" data-id="element-94">
              <p className="text-3xl md:text-4xl font-serif text-white" data-id="element-95">
                9,90€{' '}
                <span className="text-lg text-neutral-500 font-sans font-light" data-id="element-96">
                  (pago único)
                </span>
              </p>
            </div>
          </div>

          <div className="pt-4" data-id="element-97">
            <a href="https://go.hotmart.com/G104193320C?dp=1" className="inline-flex items-center justify-center bg-gold-500 hover:bg-gold-600 text-white font-medium text-xl px-12 py-5 rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] w-full md:w-auto cursor-pointer" data-id="element-98">
              Comprar Ahora
            </a>
            <p className="mt-4 text-sm text-neutral-600" data-id="element-99">
              Acceso inmediato • Compra segura • Garantía de satisfacción
            </p>
          </div>
        </div>
      </section>

      {/* Footer simple */}
      <footer className="py-8 text-center text-neutral-700 text-sm bg-black" data-id="element-100">
        <p data-id="element-101">© 2026 Santuario de Calma. Todos los derechos reservados.</p>
      </footer>
    </div>;
}